import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import Async from "./core/Async";
import AnimatedRoute from "./core/AnimatedRoute";
import NotFoundScene from "./core/NotFoundScene";
import CertificationTestAbilitiesSceneContainer from "./screens/certification-test/CertificationTestAbilitiesSceneContainer";
import CertificationTestExecutionSceneContainer from "./screens/certification-test/CertificationTestExecutionSceneContainer";
import HeaderContainer from "./core/HeaderContainer";
import CourseThemeProvider from "./core/CourseThemeProvider";
import CertificationTestResultSceneContainer from "./screens/certification-test-result/CertificationTestResultSceneContainer";
import { LOAD_STUDENT_FLOW } from "./consts";
import { useEntity, useFlow } from "./hooks";

function CourseRoutes() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <AnimatedRoute
        exact
        key="certification-test-abilities"
        path={`${path}/certification-test/:idCertificationTest/abilities`}
        component={CertificationTestAbilitiesSceneContainer}
      />
      <AnimatedRoute
        exact
        key="certification-test-execution"
        path={`${path}/certification-test/:idCertificationTest/abilities/:ability/execution`}
        component={CertificationTestExecutionSceneContainer}
      />
      <AnimatedRoute
        exact
        key="certification-test-result"
        path={`${path}/certification-test/:idCertificationTest/result`}
        component={CertificationTestResultSceneContainer}
      />
      <Route component={NotFoundScene} />
    </Switch>
  );
}

export default function UserRoutesContainer() {
  const [isLoadingStudent] = useFlow(LOAD_STUDENT_FLOW, {
    autoStart: true,
  });

  const profile = useEntity("profile", sessionStorage.getItem("id"));

  return (
    <Async fetching={isLoadingStudent || !profile}>
      <CourseThemeProvider>
        <HeaderContainer />
        <Switch>
          <Route path="/course/:idCourse">
            <CourseThemeProvider>
              <CourseRoutes />
            </CourseThemeProvider>
          </Route>
          <Route component={NotFoundScene} />
        </Switch>
      </CourseThemeProvider>
    </Async>
  );
}
